import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const HashtagLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M10 3L8 21M16 3L14 21M3 9H21M2 15H20", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
HashtagLine.iconName = 'hashtag';
HashtagLine.displayName = 'HashtagLine';
export default HashtagLine;
